import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";

export interface IDashboardSinhVienTab {
  id: string;
  sv?: IStuHoSoSinhVienViewModel;
}

export interface IDashboardSinhVienReducer {
  tabs: IDashboardSinhVienTab[];
  selectedId: string | null;
}

const iniState: IDashboardSinhVienReducer = {
  tabs: [],
  selectedId: null,
};

type IAction =
  | { type: "DSV_SET_TABS"; payload: IDashboardSinhVienTab[] }
  | { type: "DSV_SET_SELECTED"; payload: string }
  | { type: "DSV_ADD_TAB"; payload: IDashboardSinhVienTab }
  | { type: "DSV_REMOVE_TAB"; payload: string }
  | {
      type: "DSV_SET_TAB_SV";
      payload: { id: string; sv: IStuHoSoSinhVienViewModel };
    };

export const dashboardSinhVienReducer = (
  state: IDashboardSinhVienReducer = iniState,
  action: IAction,
): IDashboardSinhVienReducer => {
  switch (action.type) {
    case "DSV_SET_TABS":
      return { ...state, tabs: action.payload };
    case "DSV_SET_SELECTED":
      return { ...state, selectedId: action.payload };
    case "DSV_ADD_TAB":
      return {
        ...state,
        tabs: [...state.tabs, action.payload],
        selectedId: action.payload.id,
      };
    case "DSV_REMOVE_TAB": {
      const next = state.tabs.filter((t) => t.id !== action.payload);
      const newSelected =
        state.selectedId === action.payload
          ? next[next.length - 1]?.id ?? null
          : state.selectedId;
      return { ...state, tabs: next, selectedId: newSelected };
    }
    case "DSV_SET_TAB_SV":
      return {
        ...state,
        tabs: state.tabs.map((t) =>
          t.id === action.payload.id ? { ...t, sv: action.payload.sv } : t,
        ),
      };
    default:
      return state;
  }
};

export const dashboardSinhVienActions = {
  setTabs: (tabs: IDashboardSinhVienTab[]): IAction => ({
    type: "DSV_SET_TABS",
    payload: tabs,
  }),
  setSelected: (id: string): IAction => ({
    type: "DSV_SET_SELECTED",
    payload: id,
  }),
  addTab: (tab: IDashboardSinhVienTab): IAction => ({
    type: "DSV_ADD_TAB",
    payload: tab,
  }),
  removeTab: (id: string): IAction => ({ type: "DSV_REMOVE_TAB", payload: id }),
  setTabSv: (id: string, sv: IStuHoSoSinhVienViewModel): IAction => ({
    type: "DSV_SET_TAB_SV",
    payload: { id, sv },
  }),
};
